<template>
  <div style="width:100%">
    <b-col class="text-left">
      {{ definition.Name }}:
    </b-col>
    <b-col>
      <value-integer v-if="definition.Type == 'int'" :value="definition.Value" @valueChanged="onValueChanged" :modeRestricted="modeRestricted"/>
      <value-date v-if="definition.Type == 'date'" :value="definition.Value" @valueChanged="onValueChanged" :modeRestricted="modeRestricted"/>
      <value-select v-if="definition.Type == 'select'" :value="definition.Value" :sub-type="definition.SubType" @valueChanged="onValueChanged" :modeRestricted="modeRestricted"/>
    </b-col>
  </div>
</template>

<script>
import ValueInteger from './ValueInteger';
import ValueDate    from './ValueDate';
import ValueSelect  from './ValueSelect';

export default {
  props: {
    modeRestricted: {
      type:    Boolean,
      default: false
    },
    definition:     Object
  },
  data() {
    return {};
  },
  async created() {
    if (this.modeRestricted) {return null;}
    if (!this.definition.Value) {
      if (this.definition.DefaultValue) {
        this.definition.Value = this.definition.DefaultValue;
      }
    }
  },
  methods:    {
    onValueChanged(newValue) {
      this.definition.Value = newValue;
      this.$emit('changed', this.definition.DbName, this.definition.Value);
    }
  },
  components: {
    ValueInteger,
    ValueDate,
    ValueSelect
  }
}
</script>

<style>
</style>
